
import { defineComponent, reactive, ref, inject, watch } from "vue";
import { timeStampToTime, Toast } from "@/utils/index";

import {
  PQCProductOption,
  getProcessName,
  modelSpecificationsOption,
  checkTypeInProject,
} from "@/views/productDaily/serve/option";
import { getProductionInstructionList } from "@/request/view/productionInstruction";
import {
  productOption,
  defaultModel,
} from "@/views/productDaily/components/instruction/option";

import { useTDArray } from "@/views/productionInstruction/server";
import { useRoute } from "vue-router";

interface statistics {
  planCompleted: number,
  actualCompletion: number,
  completionRate: number | string,
}

type model = {
  label: string,
  value: string,
  data: statistics,
  col: number,
}

type process = {
  process: string,
  data: Array<model>,
  col: number
}

export default defineComponent({
  setup() {
    const route = useRoute();
    const reqPayload = reactive({
      startDate: null,
      endDate: null,
      produceOrTpc: route.meta.produceOrTpc,
      produceDate: timeStampToTime("", "upload"),
    });

    const rangeTime = ref([]);

    const tableData: any = reactive([]);

    const widthSeetings = {
      windowWidth: window.screen.width - 280,
      broadsideWidth: 160,
      tablewidth: 400,
      maxCount: 5,
    };

    const setTableData = () => {
      const list: Array<process> = [];
      // 工序
      productOption.forEach((item) => {
        const data: Array<model> = [];
        // 项目
        defaultModel.forEach((item) => {
          data.push({
            label: item.label,
            value: item.value,
            data: {
              planCompleted: 0,
              actualCompletion: 0,
              completionRate: 0,
            },
            col: 0,
          });
        });
        // 工序
        list.push({
          process: item.value,
          data,
          col: 0,
        });
      });

      return list;
    };

    // 成品多类型处理
    const handleInsertFQCModel = (list, data) => {
      const model = {
        label: data.modelSpecifications,
        value: data.modelSpecifications,
        data: {
          planCompleted: 0,
          actualCompletion: 0,
          completionRate: 0,
        },
      };
      list.push(model);

      return model;
    };

    const setProcessData = (target, processData) => {
      processData.forEach((item) => {
        const { number, modelSpecifications, pqcList } = item;

        // 需要渲染在哪个项目里
        let setModel = target.data.find((f) => f.value === modelSpecifications);

        if (!setModel && item.productName === "fqc" && pqcList) {
          setModel = handleInsertFQCModel(target.data, item);
        }

        if (!setModel || !pqcList) return;

        const qualifiedList = pqcList.filter((f) => f.status === "合格");
        // 实际完成
        setModel.data.actualCompletion += qualifiedList.length;
        // 计划完成
        setModel.data.planCompleted += number;
        // 合格率
        if (setModel.data.actualCompletion && setModel.data.planCompleted) {
          setModel.data.completionRate =
            Number(
              (setModel.data.actualCompletion / setModel.data.planCompleted) *
              100
            ).toFixed(2) + "%";
        }
      });
    };

    const getProductionData = () => {
      tableData.length = 0;
      const list = setTableData();
      getProductionInstructionList(reqPayload).then((res: any) => {
        if (
          res.code === 200 &&
          res.message === "成功" &&
          res.data &&
          Object.keys(res.data).length > 0
        ) {
          Object.keys(res.data).forEach((key) => {
            const processData = res.data[key];
            const target = list.find((f) => f.process === key);
            if (target) {
              setProcessData(target, processData);
            }
          });
        }
        tableData.push(...useTDArray(widthSeetings, list));

        console.log(list, 'tableData');
      });
    };

    const init = () => {
      getProductionData();
    };

    const handleSelectTime = (e, stringTime) => {
      const [startTime, endTime] = stringTime;
      reqPayload.produceDate = null;
      if (startTime && endTime) {
        reqPayload.startDate = startTime;
        reqPayload.endDate = endTime;
        getProductionData();
      }
    };

    const handleSelectDay = (e, stringTime) => {
      reqPayload.produceDate = stringTime;
      rangeTime.value.length = 0;
      reqPayload.startDate = null;
      reqPayload.endDate = null;
      getProductionData();
    };

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === "tasks") {
          init();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      getProcessName,
      handleSelectDay,
      reqPayload,
      tableData,
      rangeTime,
      productOption,
      handleSelectTime,
    };
  },
});
